module.exports = __webpack_public_path__ + "media/images/Icon_Facebook-7a4683b5fa7f4ef054ecac3514c45cb9.svg";